import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '@app/directives/shared.module';
import { c_side_modal_module } from '../side-modal/c_side_modal.module';

import { c_side_direction_modal_component } from './c_side_direction_modal.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    SharedModule,
    c_side_modal_module
  ],
  declarations: [
    c_side_direction_modal_component
  ],
  exports: [c_side_direction_modal_component],
})
export class c_side_direction_modal_module { }
